export default "__VITE_ASSET__396e724c__"